export default "__VITE_ASSET__c0496d5a__"